module.exports = __webpack_public_path__ + "static/media/about5.b96bcd76.svg";